import { combineReducers } from 'redux';
import store from './store';
import filters from './filters';

export default combineReducers({
    store,
    filters
});
